import React, { Component } from 'react';
import Dropzone from 'react-dropzone'
import {Field } from 'redux-form';

import classes from '../../../utils/cssClasses';
import defaultStyle from './ImportCsvDropzone.scss';

class FieldDropzone extends Component{
  constructor(props){
    super(props);
    this.style = defaultStyle;
    if (props.style){
      this.style = props.style;
    }
    
  }
  
  renderCurrentImage(files,field){
    if (files && Array.isArray(files)) {
      return (
          <img 
            className={classes('dropzone-image',this.style)}
            src={files[0].preview} alt={files[0].name} />
        );
    } else if (field.input.value){    
      return ( 
          <img
            className={classes('dropzone-image',this.style)}
            src={`/api/image/${field.input.value}`}
            alt={field.input.value} />
        );
    }
    return '';
  }

  validateType(validFormats, filesToUpload){
    console.log(validFormats,filesToUpload);
  }

  renderDropzone(field) {
    const files = field.input.value;
    return (
      <div className={`${classes('dropzone-container',this.style)} ${this.props.className}`}>
        <Dropzone
          className={classes('dropzone-item',this.style)}
          name={field.name}
          multiple={field.multiple}
          onDrop={this.props.onDropFile}
        >
          <div 
            className={classes('dropzone-hint',this.style)}
            >
            {this.props.label}
          </div>
        </Dropzone>
        {this.renderCurrentImage(files,field)}

        {field.meta.touched &&
          field.meta.error &&
          <span className={classes('error',this.style)}>{field.meta.error}</span>}
      </div>
    );
  }

  render() {
    return (
      <Field
        multiple={false}
        name={this.props.name}
        component={this.renderDropzone.bind(this)}
        // component={this.renderDropzoneInput.bind(this)}
      />
    );
  }
}

FieldDropzone.defaultProps = {
  label: "Try dropping some files here, or click to select files to upload ."
}

export default FieldDropzone;


// WEBPACK FOOTER //
// ./src/components/Backend/ImportCsvDropzone/ImportCsvDropzone.js